import { PlusCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  message,
  Divider,
  TreeSelect,
  Spin,
  Select,
} from "antd";
import React, { useState, useEffect } from "react";
import { store } from "../../../../redux/configStore";
// import {
//   getListPointMechanisms,
//   createPointMechanisms,
// } from "../../../../api/pointMechanisms/pointMechanisms";
import {
  getListZaloEvent,
  createZaloEvent,
} from "../../../../api/zaloEvent/zaloEvent";

export default function FormAddZaloEvent({
  isModalOpen,
  handleCancel,
  currentPage,
  pageSize,
}) {
  const [isLoadCreate, setIsLoadCreate] = useState(false);
  const [formRef] = Form.useForm();
  const dispatch = useDispatch();



  // Xử lý khi nhấn nút "Thêm"
  const onFinish = async (fieldsValue) => {
    const values = { ...fieldsValue };
    setIsLoadCreate(true);

    try {
      const response = await store.dispatch(createZaloEvent(values));
      if (createZaloEvent.fulfilled.match(response)) {
        if (response.payload.data.original) {
          message.error(response.payload.data.original.message);
        } else {
          message.success("Thêm cơ chế thành công");
          formRef.resetFields();
          handleCancel();
          await store.dispatch(
            getListZaloEvent({ currentPage, pageSize })
          );
        }
      } else if (createZaloEvent.rejected.match(response)) {
        handleErrors(response);
      }
    } catch (error) {
      message.error("Đã xảy ra lỗi khi tạo cơ chế.");
    } finally {
      setIsLoadCreate(false);
    }
  };

  // Hàm xử lý lỗi từ API
  const handleErrors = (response) => {
    if (response.payload.errors) {
      Object.keys(response.payload.errors).forEach((field) => {
        const errorMessages = response.payload.errors[field];
        errorMessages.forEach((errorMessage) => {
          message.error(errorMessage);
        });
      });
    } else if (response.payload.message) {
      message.error(response.payload.message);
    }
  };


  return (
    <div>
      <Modal
        title="Thêm sự kiện"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={600}
      >
        <Form
          name="addPointMechanisms"
          form={formRef}
          onFinish={onFinish}
          layout="vertical"
          requiredMark=""
        >

          {/* Mã sự kiện */}
          <Row>
            <Col span={24}>
              <Form.Item
                label="Mã sự kiện"
                name="code"
                rules={[
                  { required: true, message: "Vui lòng nhập mã sự kiện" },
                ]}
              >
                <Input placeholder="Nhập mã sự kiện" />
              </Form.Item>
            </Col>
          </Row>

          {/* Tên sự kiện*/}
          <Row>
            <Col span={24}>
              <Form.Item
                label="Tên sự kiện"
                name="name"
                rules={[{ required: true }]}
              >
                <Input placeholder="Nhập tên cơ chế" />
              </Form.Item>
            </Col>
          </Row>
          <Divider />
          {/* Nút Thêm */}
          <Row>
            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                icon={<PlusCircleOutlined />}
                loading={isLoadCreate}
                style={{ minWidth: 150 }}
              >
                Thêm cơ chế
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
}
